export default __webpack_public_path__ + "static/media/character-3.23eacad1.png";